import { useVuelidate } from '@vuelidate/core'
import { required, maxLength, email } from '@vuelidate/validators'

import { Language } from '@/enums/languages.enum'
import { Modal } from 'bootstrap';

export default {

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      user: null,
      criterias: {
        selectedEmail: '',
        selectedEmailConfirmation: '',
        selectedDescription: '',
        selectedRole: '',
        selectedLanguage: '',
        selectedDistributor: '',
        selectedInternal: false
      },
      distributorRefs: [],
      roleIdWithDistributorRef: [],
      managedRoleIds: [],
      responseErr: null,
      isProcessing: false,
      languages: Language,
      showDistributor: false,
      validationError: false,
      loggedUser: JSON.parse(sessionStorage.getItem('user')),
      selfChangeRole: false
    }
  },

  created () {
    if(!this.$store.state.users.user) {
      this.$router.replace({ path: '/vue/users' })
    }
    else {
      this.user = this.$store.state.users.user
      this.criterias.selectedEmail = this.user.email
      this.criterias.selectedEmailConfirmation = this.user.email
      this.criterias.selectedDescription = this.user.description
      this.criterias.selectedRole = this.user.ihmRoleRef
      this.criterias.selectedLanguage = this.user.language
      this.criterias.selectedDistributor = this.user.ihmDistribRef
      this.criterias.selectedInternal = this.user.internal
      this.init()
    }
  },

  methods: {
    async init () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('users/initUserUpdate', {
        idDistributeur: null
      }).then(
        response => {
          this.distributorRefs = response.distributorRefs
          this.roleIdWithDistributorRef = response.roleIdWithDistributorRef
          this.managedRoleIds = response.managedRoleIds
          this.isProcessing = false
        },
        error => {
          this.distributorRefs = []
          this.roleIdWithDistributorRef = []
          this.managedRoleIds = []
          this.error = true
          this.responseErr = error || 'BAD_REQUEST'
          this.showError(error || 'BAD_REQUEST')
        }
      )
    },

    editUser () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.edit()
      }
    },

    async edit () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null
      this.selfChangeRole = false
      if(this.loggedUser.login === this.user.login && this.criterias.selectedRole !== this.user.ihmRoleRef) {
        this.selfChangeRole = true
      }
      this.$store.dispatch('users/edit', {
        identification: this.user.login,
        email: this.criterias.selectedEmail,
        emailConfirmation: this.criterias.selectedEmailConfirmation,
        description: this.criterias.selectedDescription,
        idRole: this.criterias.selectedRole,
        language: this.criterias.selectedLanguage,
        distributorRef: this.criterias.selectedDistributor,
        isInternal: this.criterias.selectedInternal
      }).then(
        () => {
          console.log('Logged user login: ' + this.loggedUser.login)
          console.log('User login: ' + this.user.login)
          console.log('Logged user language: ' + this.loggedUser.language)
          console.log('Selected language: ' + this.criterias.selectedLanguage)
          if(this.loggedUser.login === this.user.login && this.loggedUser.language !== this.criterias.selectedLanguage) {
            console.log('locale changed')
            let locale = 'fr' // default
            if (this.criterias.selectedLanguage === 'FRENCH') {
              locale = 'fr'
            }
            if (this.criterias.selectedLanguage == 'ENGLISH') {
              locale = 'en'
            }
            localStorage.setItem('user-locale', locale);
            const user = JSON.parse(sessionStorage.getItem('user'))
            user.language = this.criterias.selectedLanguage
            sessionStorage.setItem('user', JSON.stringify(user))
            this.$store.dispatch('users/setLocaleChanged', true)
          }
          if (this.selfChangeRole) {
            successMsg = this.$i18n.t('label.user.updateSuccessSelfRole', [this.user.login] )
          }
          else {
            successMsg = this.$i18n.t('label.user.updateSuccess', [this.user.login] )
          }
          this.showSuccess(successMsg)
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    updateDistributer () {
      if (this.roleIdWithDistributorRef.some(roleId => roleId === this.criterias.selectedRole)) {
        this.showDistributor = true
      } else {
        this.showDistributor = false
        this.criterias.selectedDistributor = ''
      }
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    showError (msg) {
      let errorModal = new Modal(document.getElementById('errorModal'))
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = this.$i18n.t('error.' + msg)
    },

    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },

    leavePage () {
      if (this.selfChangeRole) {
        this.$store.dispatch('auth/logout').then(
          () => {
            this.$router.replace({ path: '/home' })
            this.$keycloak.logout()
            location.reload()
          }
        )
      }
      else {
        this.$router.push({ name: 'user-list' })
      }
    }
  },

  validations() {
    return {
      criterias: {
        selectedEmail: { required, email },
        selectedEmailConfirmation: {
          required,
          email,
          emailConfirmed () {
            return (
              this.criterias.selectedEmailConfirmation === this.criterias.selectedEmail
            )
          }
        },
        selectedDescription: { maxLength: maxLength(255) },
        selectedRole: {
          required
        },
        selectedLanguage: { required },
        selectedDistributor: {
          requiredConditioned () {
            return (
              (!this.roleIdWithDistributorRef.some(roleId => roleId === this.criterias.selectedRole)) ||
              (this.criterias.selectedDistributor && this.roleIdWithDistributorRef.some(roleId => roleId === this.criterias.selectedRole))
            )
          }
        },
        selectedInternal: { required }
      }
    }
  }
}
